module.exports = __webpack_public_path__ + "static/media/ford-map-lo.e377738d.png";